export const topStockChartData = {
  apple: {
    color: 'success',
    data: [
      ['2013/10/9', '10 AM', 275, 94.2],
      ['2013/10/9', '10:15 AM', 250, 92.5],
      ['2013/10/9', '10:30 AM', 230, 95.3],
      ['2013/10/9', '10:45 AM', 200, 85.4],
      ['2013/10/9', '11 AM', 190, 102.4],
      ['2013/10/9', '11:15 AM', 220, 84.5],
      ['2013/10/9', '11:30 AM', 230, 74.5],
      ['2013/10/9', '11:45 AM', 240, 53.5],
      ['2013/10/9', '12 PM', 240, 98.5],
      ['2013/10/9', '12:15 PM', 180, 69.5],
      ['2013/10/9', '12:30 PM', 200, 85.9],
      ['2013/10/9', '12:45 PM', 230, 95.3],
      ['2013/10/9', '1 PM', 230, 95.3],
      ['2013/10/9', '1:15 PM', 278, 98.5],
      ['2013/10/9', '1:30 PM', 220, 92.2],
      ['2013/10/9', '1:45 PM', 200, 85.4],
      ['2013/10/9', '2 PM', 200, 85.9],
      ['2013/10/9', '2:15 PM', 230, 95.0],
      ['2013/10/9', '2:30 PM', 250, 98.1],
      ['2013/10/9', '2:45 PM', 190, 84.4],
      ['2013/10/9', '3 PM', 260, 105.2],
      ['2013/10/9', '3:15 PM', 200, 89.3],
      ['2013/10/9', '3:30 PM', 185, 76.4],
      ['2013/10/9', '3:45 PM', 230, 92.6],
      ['2013/10/9', '4 PM', 265, 102.8],
      ['2013/10/9', '4:15 PM', 265, 110.5],
      ['2013/10/9', '4:30 PM', 190, 84.1],
      ['2013/10/9', '4:45 PM', 180, 76.0],
      ['2013/10/9', '5 PM', 220, 95.3],
      ['2013/10/9', '5:15 PM', 200, 89.5],
      ['2013/10/9', '5:30 PM', 272, 101.2],
      ['2013/10/9', '5:45 PM', 240, 98.7],
      ['2013/10/9', '6 PM', 230, 95.9],
      ['2013/10/9', '6:15 PM', 190, 83.2],
      ['2013/10/9', '6:30 PM', 260, 104.3],
      ['2013/10/9', '6:45 PM', 220, 92.4],
      ['2013/10/9', '7 PM', 200, 86.1],
      ['2013/10/9', '7:15 PM', 250, 101.0],
      ['2013/10/9', '7:30 PM', 230, 95.3],
      ['2013/10/9', '7:45 PM', 190, 82.5],
      ['2013/10/9', '8 PM', 220, 91.4],
      ['2013/10/9', '8:15 PM', 260, 104.6],
      ['2013/10/9', '8:30 PM', 190, 82.3],
      ['2013/10/9', '8:45 PM', 200, 86.0],
      ['2013/10/9', '9 PM', 250, 101.5],
      ['2013/10/9', '9:15 PM', 180, 74.8],
      ['2013/10/9', '9:30 PM', 258, 95.2],
      ['2013/10/9', '9:45 PM', 258, 91.0],
      ['2013/10/9', '10 PM', 190, 83.7],
      ['2013/10/9', '10:15 PM', 240, 97.4],
      ['2013/10/9', '10:30 PM', 220, 91.8],
      ['2013/10/9', '10:45 PM', 250, 102.7],
      ['2013/10/9', '11 PM', 180, 74.9],
      ['2013/10/9', '11:15 PM', 260, 104.4],
      ['2013/10/9', '11:30 PM', 200, 87.5],
      ['2013/10/9', '11:45 PM', 190, 83.1],
      ['2013/10/10', '12 AM', 230, 94.5],
      ['2013/10/10', '12:05 AM', 250, 98.5],
      ['2013/10/10', '12:15 AM', 240, 98.3],
      ['2013/10/10', '12:30 AM', 230, 95.0],
      ['2013/10/10', '12:45 AM', 220, 90.5],
      ['2013/10/10', '1 AM', 235, 92.7],
      ['2013/10/10', '1:15 AM', 200, 85.6],
      ['2013/10/10', '1:30 AM', 180, 76.8],
      ['2013/10/10', '1:45 AM', 230, 94.2],
      ['2013/10/10', '2 AM', 183, 77.1],
      ['2013/10/10', '2:15 AM', 195, 82.4],
      ['2013/10/10', '2:30 AM', 200, 85.1],
      ['2013/10/10', '2:45 AM', 185, 78.6],
      ['2013/10/10', '3 AM', 250, 101.9],
      ['2013/10/10', '3:15 AM', 190, 82.8],
      ['2013/10/10', '3:30 AM', 240, 97.2],
      ['2013/10/10', '3:45 AM', 200, 86.1],
      ['2013/10/10', '4 AM', 220, 91.7],
      ['2013/10/10', '4:15 AM', 175, 72.5],
      ['2013/10/10', '4:30 AM', 230, 94.0],
      ['2013/10/10', '4:45 AM', 210, 85.7],
      ['2013/10/10', '5 AM', 200, 83.6],
      ['2013/10/10', '5:15 AM', 240, 97.0],
      ['2013/10/10', '5:30 AM', 195, 82.3],
      ['2013/10/10', '5:45 AM', 230, 94.1],
      ['2013/10/10', '6 AM', 190, 82.0],
      ['2013/10/10', '6:15 AM', 220, 91.9],
      ['2013/10/10', '6:30 AM', 220, 91.9],
      ['2013/10/10', '6:45 AM', 180, 75.4],
      ['2013/10/10', '7 AM', 240, 97.8],
      ['2013/10/10', '7:15 AM', 250, 101.5],
      ['2013/10/10', '7:30 AM', 230, 95.3],
      ['2013/10/10', '8 AM', 190, 83.2],
      ['2013/10/10', '8:15 AM', 180, 81.2]
    ]
  },
  tesla: {
    color: 'danger',
    data: [
      ['2013-10-09', '10 AM', 277, 96.2],
      ['2013-10-09', '10:15 AM', 217, 99.4],
      ['2013-10-09', '10:30 AM', 203, 81.7],
      ['2013-10-09', '10:45 AM', 237, 92.1],
      ['2013-10-09', '11 AM', 255, 67.8],
      ['2013-10-09', '11:15 AM', 197, 82.2],
      ['2013-10-09', '11:30 AM', 201, 62],
      ['2013-10-09', '11:45 AM', 268, 78.4],
      ['2013-10-09', '12 PM', 185, 70.5],
      ['2013-10-09', '12:15 PM', 209, 82.6],
      ['2013-10-09', '12:30 PM', 217, 93.2],
      ['2013-10-09', '12:45 PM', 210, 73],
      ['2013-10-09', '1 PM', 223, 97.4],
      ['2013-10-09', '1:15 PM', 181, 77],
      ['2013-10-09', '1:30 PM', 195, 77.8],
      ['2013-10-09', '1:45 PM', 203, 89.6],
      ['2013-10-09', '2 PM', 262, 61.6],
      ['2013-10-09', '2:15 PM', 253, 92],
      ['2013-10-09', '2:30 PM', 269, 69.2],
      ['2013-10-09', '2:45 PM', 199, 88.4],
      ['2013-10-09', '3 PM', 220, 66.9],
      ['2013-10-09', '3:15 PM', 228, 61.6],
      ['2013-10-09', '3:30 PM', 240, 86.2],
      ['2013-10-09', '3:45 PM', 182, 92.8],
      ['2013-10-09', '4 PM', 259, 77.6],
      ['2013-10-09', '4:15 PM', 217, 96.6],
      ['2013-10-09', '4:30 PM', 190, 76.9],
      ['2013-10-09', '4:45 PM', 200, 76],
      ['2013-10-09', '5 PM', 244, 84.5],
      ['2013-10-09', '5:15 PM', 178, 91.5],
      ['2013-10-09', '5:30 PM', 244, 75.2],
      ['2013-10-09', '5:45 PM', 256, 80.5],
      ['2013-10-09', '6 PM', 204, 73.1],
      ['2013-10-09', '6:15 PM', 214, 82.2],
      ['2013-10-09', '6:30 PM', 214, 76.4],
      ['2013-10-09', '6:45 PM', 247, 69.1],
      ['2013-10-09', '7 PM', 230, 85.8],
      ['2013-10-09', '7:15 PM', 190, 69.9],
      ['2013-10-09', '7:30 PM', 221, 68],
      ['2013-10-09', '7:45 PM', 202, 83.5],
      ['2013-10-09', '8 PM', 189, 74],
      ['2013-10-09', '8:15 PM', 228, 89.5],
      ['2013-10-09', '8:30 PM', 262, 97.6],
      ['2013-10-09', '8:45 PM', 189, 72.6],
      ['2013-10-09', '9 PM', 260, 73.2],
      ['2013-10-09', '9:15 PM', 262, 95.1],
      ['2013-10-09', '9:30 PM', 190, 87.4],
      ['2013-10-09', '9:45 PM', 186, 73.2],
      ['2013-10-09', '10 PM', 259, 60.5],
      ['2013-10-09', '10:15 PM', 179, 81.8],
      ['2013-10-09', '10:30 PM', 250, 85],
      ['2013-10-09', '10:45 PM', 244, 72.5],
      ['2013-10-09', '11 PM', 181, 64.4],
      ['2013-10-09', '11:15 PM', 253, 89],
      ['2013-10-09', '11:30 PM', 246, 64.1],
      ['2013-10-09', '11:45 PM', 183, 73.6],
      ['2013-10-09', '12 AM', 192, 70.9],
      ['2013-10-09', '12:15 AM', 173, 73.5],
      ['2013-10-09', '12:30 AM', 208, 83.9],
      ['2013-10-09', '12:45 AM', 238, 99.9],
      ['2013-10-09', '1 AM', 172, 66.4],
      ['2013-10-09', '1:15 AM', 184, 91.8],
      ['2013-10-09', '1:30 AM', 267, 88.9],
      ['2013-10-09', '1:45 AM', 197, 99.9],
      ['2013-10-09', '2 AM', 172, 92.3],
      ['2013-10-09', '2:15 AM', 255, 93.7],
      ['2013-10-09', '2:30 AM', 201, 60.5],
      ['2013-10-09', '2:45 AM', 213, 69.4],
      ['2013-10-09', '3 AM', 209, 71.1],
      ['2013-10-09', '3:15 AM', 189, 64.1],
      ['2013-10-09', '3:30 AM', 220, 66.2],
      ['2013-10-09', '3:45 AM', 267, 89.7],
      ['2013-10-09', '4 AM', 219, 72.2],
      ['2013-10-09', '4:15 AM', 261, 96.7],
      ['2013-10-09', '4:30 AM', 183, 73.1],
      ['2013-10-09', '4:45 AM', 246, 91.8],
      ['2013-10-09', '5 AM', 203, 88.2],
      ['2013-10-09', '5:15 AM', 285, 81.3],
      ['2013-10-09', '5:30 AM', 223, 81.8],
      ['2013-10-09', '5:45 AM', 247, 78.8],
      ['2013-10-10', '6 AM', 184, 95.8],
      ['2013-10-10', '6:15 AM', 179, 84.2],
      ['2013-10-10', '6:30 AM', 179, 65.3],
      ['2013-10-10', '6:45 AM', 185, 73.1],
      ['2013-10-10', '7 AM', 230, 82.4],
      ['2013-10-10', '7:15 AM', 172, 80.4],
      ['2013-10-10', '7:30 AM', 248, 92.5],
      ['2013-10-10', '7:45 AM', 194, 63.4],
      ['2013-10-10', '8 AM', 196, 90.6]
    ]
  },
  nvidia: {
    color: 'success',
    data: [
      ['2013-10-09', '10 AM', 241, 62.8],
      ['2013-10-09', '10:15 AM', 203, 70.1],
      ['2013-10-09', '10:30 AM', 234, 62.8],
      ['2013-10-09', '10:45 AM', 255, 70.9],
      ['2013-10-09', '11 AM', 189, 95.4],
      ['2013-10-09', '11:15 AM', 239, 93.3],
      ['2013-10-09', '11:30 AM', 255, 69.1],
      ['2013-10-09', '11:45 AM', 218, 87.9],
      ['2013-10-09', '12 PM', 200, 66.2],
      ['2013-10-09', '12:15 PM', 218, 70.4],
      ['2013-10-09', '12:30 PM', 244, 96.3],
      ['2013-10-09', '12:45 PM', 184, 94.5],
      ['2013-10-09', '1 PM', 214, 73.9],
      ['2013-10-09', '1:15 PM', 238, 97.1],
      ['2013-10-09', '1:30 PM', 222, 75.7],
      ['2013-10-09', '1:45 PM', 172, 71.5],
      ['2013-10-09', '2 PM', 249, 80.7],
      ['2013-10-09', '2:15 PM', 232, 79.2],
      ['2013-10-09', '2:30 PM', 246, 97.9],
      ['2013-10-09', '2:45 PM', 185, 95.2],
      ['2013-10-09', '3 PM', 287, 66.1],
      ['2013-10-09', '3:15 PM', 205, 98.9],
      ['2013-10-09', '3:30 PM', 207, 79.8],
      ['2013-10-09', '3:45 PM', 200, 75.6],
      ['2013-10-09', '4 PM', 263, 76],
      ['2013-10-09', '4:15 PM', 230, 94],
      ['2013-10-09', '4:30 PM', 187, 62.2],
      ['2013-10-09', '4:45 PM', 191, 63.6],
      ['2013-10-09', '5 PM', 196, 72.1],
      ['2013-10-09', '5:15 PM', 235, 96.1],
      ['2013-10-09', '5:30 PM', 247, 95.4],
      ['2013-10-09', '5:45 PM', 286, 74.9],
      ['2013-10-09', '6 PM', 175, 89.3],
      ['2013-10-09', '6:15 PM', 208, 73.3],
      ['2013-10-09', '6:30 PM', 233, 99.8],
      ['2013-10-09', '6:45 PM', 184, 75.3],
      ['2013-10-09', '7 PM', 258, 63.3],
      ['2013-10-09', '7:15 PM', 221, 98.6],
      ['2013-10-09', '7:30 PM', 194, 99.6],
      ['2013-10-09', '7:45 PM', 193, 86.4],
      ['2013-10-09', '8 PM', 179, 88.7],
      ['2013-10-09', '8:15 PM', 199, 81],
      ['2013-10-09', '8:30 PM', 214, 78.2],
      ['2013-10-09', '8:45 PM', 203, 69],
      ['2013-10-09', '9 PM', 278, 75.5],
      ['2013-10-09', '9:15 PM', 189, 76.4],
      ['2013-10-09', '9:30 PM', 228, 76],
      ['2013-10-09', '9:45 PM', 222, 86.5],
      ['2013-10-09', '10 PM', 175, 66],
      ['2013-10-09', '10:15 PM', 174, 60.9],
      ['2013-10-09', '10:30 PM', 207, 66.2],
      ['2013-10-09', '10:45 PM', 233, 79.4],
      ['2013-10-09', '11 PM', 195, 66.4],
      ['2013-10-09', '11:15 PM', 206, 62.8],
      ['2013-10-09', '11:30 PM', 228, 76.6],
      ['2013-10-09', '11:45 PM', 245, 70.7],
      ['2013-10-09', '12 AM', 187, 97.2],
      ['2013-10-09', '12:15 AM', 253, 65.1],
      ['2013-10-09', '12:30 AM', 236, 90],
      ['2013-10-09', '12:45 AM', 189, 96],
      ['2013-10-09', '1 AM', 173, 84.2],
      ['2013-10-09', '1:15 AM', 252, 85.9],
      ['2013-10-09', '1:30 AM', 253, 62.9],
      ['2013-10-09', '1:45 AM', 183, 68.2],
      ['2013-10-09', '2 AM', 172, 76],
      ['2013-10-09', '2:15 AM', 209, 70.3],
      ['2013-10-09', '2:30 AM', 195, 84.8],
      ['2013-10-09', '2:45 AM', 182, 98.1],
      ['2013-10-09', '3 AM', 231, 73.4],
      ['2013-10-09', '3:15 AM', 201, 86.9],
      ['2013-10-09', '3:30 AM', 207, 81.8],
      ['2013-10-09', '3:45 AM', 264, 92.9],
      ['2013-10-09', '4 AM', 233, 73.4],
      ['2013-10-09', '4:15 AM', 260, 69.8],
      ['2013-10-09', '4:30 AM', 244, 60.7],
      ['2013-10-09', '4:45 AM', 266, 83.3],
      ['2013-10-09', '5 AM', 237, 84.8],
      ['2013-10-09', '5:15 AM', 223, 84.5],
      ['2013-10-09', '5:30 AM', 207, 72.9],
      ['2013-10-09', '5:45 AM', 217, 94.6],
      ['2013-10-10', '6 AM', 252, 87.6],
      ['2013-10-10', '6:15 AM', 173, 82.3],
      ['2013-10-10', '6:30 AM', 227, 65.9],
      ['2013-10-10', '6:45 AM', 194, 96.8],
      ['2013-10-10', '7 AM', 175, 83.5],
      ['2013-10-10', '7:15 AM', 243, 68.7],
      ['2013-10-10', '7:30 AM', 183, 91.7],
      ['2013-10-10', '7:45 AM', 201, 61.7],
      ['2013-10-10', '8 AM', 267, 97.1]
    ]
  },
  alphabet: {
    color: 'success',
    data: [
      ['2013-10-09', '10 AM', 172, 67.2],
      ['2013-10-09', '10:15 AM', 190, 66.9],
      ['2013-10-09', '10:30 AM', 253, 89.1],
      ['2013-10-09', '10:45 AM', 279, 67.3],
      ['2013-10-09', '11 AM', 282, 91.5],
      ['2013-10-09', '11:15 AM', 211, 90.9],
      ['2013-10-09', '11:30 AM', 231, 79.8],
      ['2013-10-09', '11:45 AM', 220, 67.1],
      ['2013-10-09', '12 PM', 254, 95.4],
      ['2013-10-09', '12:15 PM', 189, 77.3],
      ['2013-10-09', '12:30 PM', 236, 86.3],
      ['2013-10-09', '12:45 PM', 265, 87.8],
      ['2013-10-09', '1 PM', 266, 85.3],
      ['2013-10-09', '1:15 PM', 224, 91.6],
      ['2013-10-09', '1:30 PM', 213, 62.9],
      ['2013-10-09', '1:45 PM', 254, 84.9],
      ['2013-10-09', '2 PM', 192, 76.3],
      ['2013-10-09', '2:15 PM', 172, 97.5],
      ['2013-10-09', '2:30 PM', 204, 94.8],
      ['2013-10-09', '2:45 PM', 192, 80.6],
      ['2013-10-09', '3 PM', 264, 93.6],
      ['2013-10-09', '3:15 PM', 245, 91.8],
      ['2013-10-09', '3:30 PM', 267, 95.9],
      ['2013-10-09', '3:45 PM', 260, 60.6],
      ['2013-10-09', '4 PM', 184, 75.9],
      ['2013-10-09', '4:15 PM', 176, 88.6],
      ['2013-10-09', '4:30 PM', 201, 75.6],
      ['2013-10-09', '4:45 PM', 229, 90.7],
      ['2013-10-09', '5 PM', 231, 70.5],
      ['2013-10-09', '5:15 PM', 257, 84.7],
      ['2013-10-09', '5:30 PM', 213, 84.5],
      ['2013-10-09', '5:45 PM', 243, 63.9],
      ['2013-10-09', '6 PM', 258, 74.7],
      ['2013-10-09', '6:15 PM', 215, 71.3],
      ['2013-10-09', '6:30 PM', 266, 60.7],
      ['2013-10-09', '6:45 PM', 197, 99.2],
      ['2013-10-09', '7 PM', 247, 78.2],
      ['2013-10-09', '7:15 PM', 248, 69.1],
      ['2013-10-09', '7:30 PM', 176, 79.6],
      ['2013-10-09', '7:45 PM', 171, 67.6],
      ['2013-10-09', '8 PM', 263, 70.1],
      ['2013-10-09', '8:15 PM', 198, 85.2],
      ['2013-10-09', '8:30 PM', 249, 67.6],
      ['2013-10-09', '8:45 PM', 242, 99.5],
      ['2013-10-09', '9 PM', 214, 92.3],
      ['2013-10-09', '9:15 PM', 196, 62.9],
      ['2013-10-09', '9:30 PM', 230, 92.7],
      ['2013-10-09', '9:45 PM', 182, 97.4],
      ['2013-10-09', '10 PM', 180, 81.9],
      ['2013-10-09', '10:15 PM', 194, 96.3],
      ['2013-10-09', '10:30 PM', 196, 74.2],
      ['2013-10-09', '10:45 PM', 185, 79.1],
      ['2013-10-09', '11 PM', 267, 86.7],
      ['2013-10-09', '11:15 PM', 262, 70.3],
      ['2013-10-09', '11:30 PM', 179, 66.5],
      ['2013-10-09', '11:45 PM', 210, 83.3],
      ['2013-10-09', '12 AM', 244, 96.1],
      ['2013-10-09', '12:15 AM', 244, 63.8],
      ['2013-10-09', '12:30 AM', 266, 87.5],
      ['2013-10-09', '12:45 AM', 205, 69.2],
      ['2013-10-09', '1 AM', 268, 91.5],
      ['2013-10-09', '1:15 AM', 172, 93.1],
      ['2013-10-09', '1:30 AM', 257, 63.5],
      ['2013-10-09', '1:45 AM', 204, 94.8],
      ['2013-10-09', '2 AM', 237, 93.7],
      ['2013-10-09', '2:15 AM', 230, 95.2],
      ['2013-10-09', '2:30 AM', 195, 76.1],
      ['2013-10-09', '2:45 AM', 217, 98.3],
      ['2013-10-09', '3 AM', 189, 95.4],
      ['2013-10-09', '3:15 AM', 261, 71.2],
      ['2013-10-09', '3:30 AM', 194, 97.3],
      ['2013-10-09', '3:45 AM', 219, 69.3],
      ['2013-10-09', '4 AM', 264, 70.1],
      ['2013-10-09', '4:15 AM', 251, 77.6],
      ['2013-10-09', '4:30 AM', 200, 88.6],
      ['2013-10-09', '4:45 AM', 265, 67.7],
      ['2013-10-09', '5 AM', 226, 87.3],
      ['2013-10-09', '5:15 AM', 197, 89.5],
      ['2013-10-09', '5:30 AM', 240, 87],
      ['2013-10-09', '5:45 AM', 247, 68.7],
      ['2013-10-10', '6 AM', 247, 68],
      ['2013-10-10', '6:15 AM', 186, 62.3],
      ['2013-10-10', '6:30 AM', 182, 65],
      ['2013-10-10', '6:45 AM', 221, 71.4],
      ['2013-10-10', '7 AM', 181, 63.1],
      ['2013-10-10', '7:15 AM', 197, 66],
      ['2013-10-10', '7:30 AM', 197, 77.7],
      ['2013-10-10', '7:45 AM', 259, 61.6],
      ['2013-10-10', '8 AM', 250, 91.6]
    ]
  },
  amd: {
    color: 'success',
    data: [
      ['2013-10-09', '10 AM', 257, 76.4],
      ['2013-10-09', '10:15 AM', 289, 70.6],
      ['2013-10-09', '10:30 AM', 274, 63.7],
      ['2013-10-09', '10:45 AM', 263, 87.2],
      ['2013-10-09', '11 AM', 208, 68.1],
      ['2013-10-09', '11:15 AM', 187, 63.7],
      ['2013-10-09', '11:30 AM', 229, 91.1],
      ['2013-10-09', '11:45 AM', 218, 77.7],
      ['2013-10-09', '12 PM', 212, 86.5],
      ['2013-10-09', '12:15 PM', 231, 95],
      ['2013-10-09', '12:30 PM', 186, 64.4],
      ['2013-10-09', '12:45 PM', 235, 76],
      ['2013-10-09', '1 PM', 209, 91.2],
      ['2013-10-09', '1:15 PM', 193, 95.5],
      ['2013-10-09', '1:30 PM', 211, 86.3],
      ['2013-10-09', '1:45 PM', 251, 69.9],
      ['2013-10-09', '2 PM', 220, 99.2],
      ['2013-10-09', '2:15 PM', 287, 85.5],
      ['2013-10-09', '2:30 PM', 253, 95.4],
      ['2013-10-09', '2:45 PM', 265, 95.4],
      ['2013-10-09', '3 PM', 184, 81],
      ['2013-10-09', '3:15 PM', 195, 84.7],
      ['2013-10-09', '3:30 PM', 209, 83.5],
      ['2013-10-09', '3:45 PM', 196, 69.5],
      ['2013-10-09', '4 PM', 189, 96.4],
      ['2013-10-09', '4:15 PM', 180, 67.9],
      ['2013-10-09', '4:30 PM', 258, 85.7],
      ['2013-10-09', '4:45 PM', 203, 95.7],
      ['2013-10-09', '5 PM', 188, 87.3],
      ['2013-10-09', '5:15 PM', 215, 82.5],
      ['2013-10-09', '5:30 PM', 268, 73.4],
      ['2013-10-09', '5:45 PM', 194, 73.7],
      ['2013-10-09', '6 PM', 180, 91.8],
      ['2013-10-09', '6:15 PM', 233, 72.7],
      ['2013-10-09', '6:30 PM', 236, 81.3],
      ['2013-10-09', '6:45 PM', 195, 86.5],
      ['2013-10-09', '7 PM', 206, 78.2],
      ['2013-10-09', '7:15 PM', 193, 85.7],
      ['2013-10-09', '7:30 PM', 212, 70.4],
      ['2013-10-09', '7:45 PM', 197, 89.4],
      ['2013-10-09', '8 PM', 249, 66.4],
      ['2013-10-09', '8:15 PM', 247, 67.3],
      ['2013-10-09', '8:30 PM', 265, 94],
      ['2013-10-09', '8:45 PM', 252, 70],
      ['2013-10-09', '9 PM', 238, 63.6],
      ['2013-10-09', '9:15 PM', 235, 92.4],
      ['2013-10-09', '9:30 PM', 174, 66.8],
      ['2013-10-09', '9:45 PM', 253, 65.7],
      ['2013-10-09', '10 PM', 210, 67.6],
      ['2013-10-09', '10:15 PM', 192, 84],
      ['2013-10-09', '10:30 PM', 199, 73],
      ['2013-10-09', '10:45 PM', 228, 62.2],
      ['2013-10-09', '11 PM', 229, 68.9],
      ['2013-10-09', '11:15 PM', 215, 95.2],
      ['2013-10-09', '11:30 PM', 272, 74.9],
      ['2013-10-09', '11:45 PM', 288, 82.2],
      ['2013-10-09', '12 AM', 211, 71.1],
      ['2013-10-09', '12:15 AM', 285, 70.7],
      ['2013-10-09', '12:30 AM', 213, 96.3],
      ['2013-10-09', '12:45 AM', 205, 81],
      ['2013-10-09', '1 AM', 206, 63],
      ['2013-10-09', '1:15 AM', 271, 79.2],
      ['2013-10-09', '1:30 AM', 232, 75.6],
      ['2013-10-09', '1:45 AM', 233, 66.5],
      ['2013-10-09', '2 AM', 217, 95.2],
      ['2013-10-09', '2:15 AM', 190, 89.5],
      ['2013-10-09', '2:30 AM', 214, 94.7],
      ['2013-10-09', '2:45 AM', 281, 87.1],
      ['2013-10-09', '3 AM', 211, 67.3],
      ['2013-10-09', '3:15 AM', 249, 97.2],
      ['2013-10-09', '3:30 AM', 256, 64.9],
      ['2013-10-09', '3:45 AM', 210, 96.5],
      ['2013-10-09', '4 AM', 191, 79.4],
      ['2013-10-09', '4:15 AM', 222, 95.3],
      ['2013-10-09', '4:30 AM', 230, 93.8],
      ['2013-10-09', '4:45 AM', 264, 81.1],
      ['2013-10-09', '5 AM', 180, 70.8],
      ['2013-10-09', '5:15 AM', 247, 73.4],
      ['2013-10-09', '5:30 AM', 283, 74],
      ['2013-10-09', '5:45 AM', 219, 76.7],
      ['2013-10-10', '6 AM', 252, 64.4],
      ['2013-10-10', '6:15 AM', 233, 62.2],
      ['2013-10-10', '6:30 AM', 177, 65.8],
      ['2013-10-10', '6:45 AM', 284, 91.1],
      ['2013-10-10', '7 AM', 219, 88.8],
      ['2013-10-10', '7:15 AM', 234, 79.6],
      ['2013-10-10', '7:30 AM', 217, 96.2],
      ['2013-10-10', '7:45 AM', 231, 95],
      ['2013-10-10', '8 AM', 198, 95.5]
    ]
  },
  microsoft: {
    color: 'success',
    data: [
      ['2013-10-09', '10 AM', 284, 65.4],
      ['2013-10-09', '10:15 AM', 174, 84.3],
      ['2013-10-09', '10:30 AM', 261, 74.7],
      ['2013-10-09', '10:45 AM', 286, 96.3],
      ['2013-10-09', '11 AM', 177, 74.2],
      ['2013-10-09', '11:15 AM', 238, 90.3],
      ['2013-10-09', '11:30 AM', 260, 69.3],
      ['2013-10-09', '11:45 AM', 196, 87.1],
      ['2013-10-09', '12 PM', 192, 79.7],
      ['2013-10-09', '12:15 PM', 172, 78.8],
      ['2013-10-09', '12:30 PM', 271, 78.5],
      ['2013-10-09', '12:45 PM', 251, 93.9],
      ['2013-10-09', '1 PM', 237, 83.2],
      ['2013-10-09', '1:15 PM', 224, 81.6],
      ['2013-10-09', '1:30 PM', 242, 94.9],
      ['2013-10-09', '1:45 PM', 250, 94.9],
      ['2013-10-09', '2 PM', 247, 91.7],
      ['2013-10-09', '2:15 PM', 249, 67.4],
      ['2013-10-09', '2:30 PM', 189, 72.4],
      ['2013-10-09', '2:45 PM', 201, 62.6],
      ['2013-10-09', '3 PM', 229, 95.1],
      ['2013-10-09', '3:15 PM', 271, 87.9],
      ['2013-10-09', '3:30 PM', 250, 99.4],
      ['2013-10-09', '3:45 PM', 227, 80.4],
      ['2013-10-09', '4 PM', 235, 98.5],
      ['2013-10-09', '4:15 PM', 178, 70.1],
      ['2013-10-09', '4:30 PM', 191, 90.6],
      ['2013-10-09', '4:45 PM', 220, 84.2],
      ['2013-10-09', '5 PM', 263, 96.4],
      ['2013-10-09', '5:15 PM', 267, 65.5],
      ['2013-10-09', '5:30 PM', 286, 78.6],
      ['2013-10-09', '5:45 PM', 287, 60.7],
      ['2013-10-09', '6 PM', 259, 79.4],
      ['2013-10-09', '6:15 PM', 191, 85],
      ['2013-10-09', '6:30 PM', 212, 83.5],
      ['2013-10-09', '6:45 PM', 183, 81],
      ['2013-10-09', '7 PM', 253, 76.8],
      ['2013-10-09', '7:15 PM', 194, 64.7],
      ['2013-10-09', '7:30 PM', 196, 78.4],
      ['2013-10-09', '7:45 PM', 174, 84],
      ['2013-10-09', '8 PM', 214, 92.3],
      ['2013-10-09', '8:15 PM', 205, 66.8],
      ['2013-10-09', '8:30 PM', 262, 96.5],
      ['2013-10-09', '8:45 PM', 191, 97.4],
      ['2013-10-09', '9 PM', 223, 69.2],
      ['2013-10-09', '9:15 PM', 242, 87.3],
      ['2013-10-09', '9:30 PM', 176, 60.3],
      ['2013-10-09', '9:45 PM', 172, 95.7],
      ['2013-10-09', '10 PM', 209, 62.6],
      ['2013-10-09', '10:15 PM', 286, 71.1],
      ['2013-10-09', '10:30 PM', 265, 77.7],
      ['2013-10-09', '10:45 PM', 237, 90.1],
      ['2013-10-09', '11 PM', 251, 83.7],
      ['2013-10-09', '11:15 PM', 217, 60.1],
      ['2013-10-09', '11:30 PM', 207, 65.6],
      ['2013-10-09', '11:45 PM', 181, 68.5],
      ['2013-10-09', '12 AM', 171, 95.8],
      ['2013-10-09', '12:15 AM', 211, 81.4],
      ['2013-10-09', '12:30 AM', 247, 86.5],
      ['2013-10-09', '12:45 AM', 211, 67.6],
      ['2013-10-09', '1 AM', 180, 64.1],
      ['2013-10-09', '1:15 AM', 227, 78.1],
      ['2013-10-09', '1:30 AM', 197, 67.5],
      ['2013-10-09', '1:45 AM', 212, 64.5],
      ['2013-10-09', '2 AM', 261, 95.1],
      ['2013-10-09', '2:15 AM', 192, 65.3],
      ['2013-10-09', '2:30 AM', 247, 62.8],
      ['2013-10-09', '2:45 AM', 177, 78.9],
      ['2013-10-09', '3 AM', 243, 86.7],
      ['2013-10-09', '3:15 AM', 182, 83.2],
      ['2013-10-09', '3:30 AM', 262, 82.7],
      ['2013-10-09', '3:45 AM', 270, 67.4],
      ['2013-10-09', '4 AM', 171, 63.4],
      ['2013-10-09', '4:15 AM', 207, 73.2],
      ['2013-10-09', '4:30 AM', 257, 84],
      ['2013-10-09', '4:45 AM', 185, 99.4],
      ['2013-10-09', '5 AM', 185, 79.2],
      ['2013-10-09', '5:15 AM', 243, 67.7],
      ['2013-10-09', '5:30 AM', 219, 84.2],
      ['2013-10-09', '5:45 AM', 285, 91.1],
      ['2013-10-10', '6 AM', 269, 69.6],
      ['2013-10-10', '6:15 AM', 189, 89.2],
      ['2013-10-10', '6:30 AM', 243, 72.8],
      ['2013-10-10', '6:45 AM', 269, 71.2],
      ['2013-10-10', '7 AM', 227, 63.8],
      ['2013-10-10', '7:15 AM', 244, 73.4],
      ['2013-10-10', '7:30 AM', 284, 86.3],
      ['2013-10-10', '7:45 AM', 224, 72.6],
      ['2013-10-10', '8 AM', 207, 60.4]
    ]
  },
  intel: {
    color: 'success',
    data: [
      ['2013-10-09', '10 AM', 208, 76.7],
      ['2013-10-09', '10:15 AM', 209, 78.2],
      ['2013-10-09', '10:30 AM', 198, 62.1],
      ['2013-10-09', '10:45 AM', 261, 78.9],
      ['2013-10-09', '11 AM', 247, 97.6],
      ['2013-10-09', '11:15 AM', 215, 70.6],
      ['2013-10-09', '11:30 AM', 210, 80.1],
      ['2013-10-09', '11:45 AM', 210, 95.5],
      ['2013-10-09', '12 PM', 200, 84.6],
      ['2013-10-09', '12:15 PM', 216, 76.4],
      ['2013-10-09', '12:30 PM', 224, 88.3],
      ['2013-10-09', '12:45 PM', 236, 74.4],
      ['2013-10-09', '1 PM', 208, 71],
      ['2013-10-09', '1:15 PM', 232, 78.2],
      ['2013-10-09', '1:30 PM', 222, 80.5],
      ['2013-10-09', '1:45 PM', 221, 91.4],
      ['2013-10-09', '2 PM', 266, 85.8],
      ['2013-10-09', '2:15 PM', 180, 86.1],
      ['2013-10-09', '2:30 PM', 243, 90.1],
      ['2013-10-09', '2:45 PM', 199, 68.4],
      ['2013-10-09', '3 PM', 222, 67.2],
      ['2013-10-09', '3:15 PM', 184, 97.5],
      ['2013-10-09', '3:30 PM', 228, 78.2],
      ['2013-10-09', '3:45 PM', 182, 80],
      ['2013-10-09', '4 PM', 186, 76.7],
      ['2013-10-09', '4:15 PM', 191, 77.5],
      ['2013-10-09', '4:30 PM', 195, 71.1],
      ['2013-10-09', '4:45 PM', 182, 68.3],
      ['2013-10-09', '5 PM', 277, 63],
      ['2013-10-09', '5:15 PM', 181, 95.8],
      ['2013-10-09', '5:30 PM', 270, 69.5],
      ['2013-10-09', '5:45 PM', 283, 75.9],
      ['2013-10-09', '6 PM', 265, 93.9],
      ['2013-10-09', '6:15 PM', 204, 84.8],
      ['2013-10-09', '6:30 PM', 170, 82],
      ['2013-10-09', '6:45 PM', 221, 71.7],
      ['2013-10-09', '7 PM', 173, 86],
      ['2013-10-09', '7:15 PM', 212, 93],
      ['2013-10-09', '7:30 PM', 240, 87.3],
      ['2013-10-09', '7:45 PM', 258, 86.7],
      ['2013-10-09', '8 PM', 198, 89.2],
      ['2013-10-09', '8:15 PM', 234, 87.2],
      ['2013-10-09', '8:30 PM', 267, 87],
      ['2013-10-09', '8:45 PM', 278, 85.2],
      ['2013-10-09', '9 PM', 287, 95.8],
      ['2013-10-09', '9:15 PM', 172, 86.6],
      ['2013-10-09', '9:30 PM', 259, 60.2],
      ['2013-10-09', '9:45 PM', 212, 99.7],
      ['2013-10-09', '10 PM', 222, 61.2],
      ['2013-10-09', '10:15 PM', 245, 72.2],
      ['2013-10-09', '10:30 PM', 190, 80.5],
      ['2013-10-09', '10:45 PM', 185, 67.1],
      ['2013-10-09', '11 PM', 180, 70],
      ['2013-10-09', '11:15 PM', 199, 71.5],
      ['2013-10-09', '11:30 PM', 230, 65.9],
      ['2013-10-09', '11:45 PM', 269, 87.9],
      ['2013-10-09', '12 AM', 180, 61.3],
      ['2013-10-09', '12:15 AM', 258, 99.1],
      ['2013-10-09', '12:30 AM', 220, 71.3],
      ['2013-10-09', '12:45 AM', 275, 92.1],
      ['2013-10-09', '1 AM', 230, 79],
      ['2013-10-09', '1:15 AM', 271, 88.2],
      ['2013-10-09', '1:30 AM', 243, 74.3],
      ['2013-10-09', '1:45 AM', 193, 76.4],
      ['2013-10-09', '2 AM', 202, 72.3],
      ['2013-10-09', '2:15 AM', 217, 87.8],
      ['2013-10-09', '2:30 AM', 187, 98.6],
      ['2013-10-09', '2:45 AM', 251, 99.4],
      ['2013-10-09', '3 AM', 201, 87.7],
      ['2013-10-09', '3:15 AM', 230, 95.1],
      ['2013-10-09', '3:30 AM', 199, 60.2],
      ['2013-10-09', '3:45 AM', 230, 80.3],
      ['2013-10-09', '4 AM', 214, 77.9],
      ['2013-10-09', '4:15 AM', 174, 71.8],
      ['2013-10-09', '4:30 AM', 230, 91],
      ['2013-10-09', '4:45 AM', 253, 99.2],
      ['2013-10-09', '5 AM', 217, 63.6],
      ['2013-10-09', '5:15 AM', 172, 72.7],
      ['2013-10-09', '5:30 AM', 284, 75.6],
      ['2013-10-09', '5:45 AM', 251, 65.4],
      ['2013-10-10', '6 AM', 202, 70.7],
      ['2013-10-10', '6:15 AM', 221, 63.2],
      ['2013-10-10', '6:30 AM', 212, 68.7],
      ['2013-10-10', '6:45 AM', 204, 78.1],
      ['2013-10-10', '7 AM', 197, 68.5],
      ['2013-10-10', '7:15 AM', 190, 79.6],
      ['2013-10-10', '7:30 AM', 262, 89.8],
      ['2013-10-10', '7:45 AM', 275, 98.2],
      ['2013-10-10', '8 AM', 283, 61]
    ]
  }
};

export const portfolioLineChartData = {
  '1d': [
    ['9 AM', 90],
    ['9:30 AM', 82],
    ['10 AM', 57],
    ['10:30 AM', 85],
    ['11 AM', 86],
    ['11:30 AM', 78],
    ['12 PM', 93],
    ['12:30 PM', 71],
    ['1 PM', 69],
    ['1:30 PM', 81],
    ['2 PM', 57],
    ['2:30 PM', 40],
    ['3 PM', 68],
    ['3:30 PM', 72],
    ['4 PM', 61]
  ],
  '5d': [
    ['2025-03-05', 45],
    ['2025-03-06', 38],
    ['2024-03-07', 54],
    ['2025-03-08', 48],
    ['2025-03-09', 55]
  ],
  '1m': [
    ['2025-02-08', 47],
    ['2025-02-09', 62],
    ['2025-02-10', 68],
    ['2025-02-11', 82],
    ['2025-02-12', 82],
    ['2025-02-13', 93],
    ['2025-02-14', 88],
    ['2025-02-15', 73],
    ['2025-02-16', 90],
    ['2025-02-17', 72],
    ['2025-02-18', 76],
    ['2025-02-19', 43],
    ['2025-02-20', 76],
    ['2025-02-21', 43],
    ['2025-02-22', 56],
    ['2025-02-23', 83],
    ['2025-02-24', 92],
    ['2025-02-25', 43],
    ['2025-02-26', 52],
    ['2025-02-27', 62],
    ['2025-02-28', 59],
    ['2025-03-01', 52],
    ['2025-03-02', 76],
    ['2025-03-03', 69],
    ['2025-03-04', 55],
    ['2025-03-05', 54],
    ['2025-03-06', 90],
    ['2025-03-07', 59],
    ['2025-03-08', 41],
    ['2025-03-09', 75]
  ],
  '3m': [
    ['2024-12-02', 45],
    ['2024-12-07', 38],
    ['2024-12-12', 54],
    ['2024-12-17', 48],
    ['2024-12-22', 55],
    ['2024-12-27', 56],

    ['2025-01-03', 59],
    ['2025-01-08', 54],
    ['2025-01-13', 54],
    ['2025-01-18', 58],
    ['2025-01-23', 60],
    ['2025-01-28', 58],

    ['2025-02-04', 58],
    ['2025-02-09', 64],
    ['2025-02-14', 65],
    ['2025-02-22', 58],
    ['2025-03-03', 67],
    ['2025-03-10', 72]
  ],
  '6m': [
    ['2024-10-01', 57],
    ['2024-11-01', 48],
    ['2024-12-01', 61],
    ['2025-01-01', 54],
    ['2025-02-01', 82],
    ['2025-03-01', 78]
  ],
  '1y': [
    ['2024-03-10', 45],
    ['2024-03-15', 38],
    ['2024-03-20', 54],
    ['2024-03-25', 48],
    ['2024-03-30', 55],
    ['2024-04-04', 56],

    ['2024-04-10', 59],
    ['2024-04-15', 54],
    ['2024-04-20', 54],
    ['2024-04-25', 58],
    ['2024-04-30', 60],
    ['2024-05-05', 58],

    ['2024-05-10', 58],
    ['2024-05-15', 64],
    ['2024-05-20', 65],
    ['2024-05-25', 58],
    ['2024-05-30', 67],
    ['2024-06-04', 72],

    ['2024-06-09', 68],
    ['2024-06-14', 65],
    ['2024-06-19', 72],
    ['2024-06-24', 66],
    ['2024-06-29', 71],
    ['2024-07-04', 72],

    ['2024-07-09', 80],
    ['2024-07-14', 69],
    ['2024-07-19', 67],
    ['2024-07-24', 73],
    ['2024-07-29', 92],
    ['2024-08-03', 89],

    ['2024-08-08', 82],
    ['2024-08-13', 95],
    ['2024-08-18', 91],
    ['2024-08-23', 89],
    ['2024-08-28', 73],
    ['2024-09-02', 80],

    ['2024-09-07', 86],
    ['2024-09-12', 65],
    ['2024-09-17', 74],
    ['2024-09-22', 83],
    ['2024-09-27', 91],
    ['2024-10-02', 74],

    ['2024-10-07', 72],
    ['2024-10-12', 85],
    ['2024-10-17', 71],
    ['2024-10-22', 78],
    ['2024-10-27', 70],
    ['2024-11-01', 88],

    ['2024-11-06', 85],
    ['2024-11-11', 70],
    ['2024-11-16', 86],
    ['2024-11-21', 94],
    ['2024-11-26', 90],
    ['2024-12-01', 74],

    ['2024-12-06', 76],
    ['2024-12-11', 90],
    ['2024-12-16', 82],
    ['2024-12-21', 83],
    ['2024-12-26', 85],
    ['2024-12-31', 80],

    ['2025-01-05', 81],
    ['2025-01-10', 91],
    ['2025-01-15', 90],
    ['2025-01-20', 93],
    ['2025-01-25', 94],
    ['2025-01-30', 95],

    ['2025-02-04', 90],
    ['2025-02-09', 90],
    ['2025-02-14', 86],
    ['2025-02-19', 95],
    ['2025-02-24', 91],
    ['2025-02-28', 90],

    ['2025-03-05', 94],
    ['2025-03-10', 90]
  ],
  all: [
    ['2015-01-01', 46],
    ['2015-02-01', 55],
    ['2015-03-01', 64],
    ['2015-04-01', 70],
    ['2015-05-01', 58],
    ['2015-06-01', 75],
    ['2015-07-01', 85],
    ['2015-08-01', 74],
    ['2015-09-01', 66],
    ['2015-10-01', 80],
    ['2015-11-01', 90],
    ['2015-12-01', 65],

    ['2016-01-01', 48],
    ['2016-02-01', 57],
    ['2016-03-01', 67],
    ['2016-04-01', 72],
    ['2016-05-01', 60],
    ['2016-06-01', 77],
    ['2016-07-01', 88],
    ['2016-08-01', 75],
    ['2016-09-01', 68],
    ['2016-10-01', 82],
    ['2016-11-01', 92],
    ['2016-12-01', 67],

    ['2017-01-01', 50],
    ['2017-02-01', 60],
    ['2017-03-01', 69],
    ['2017-04-01', 75],
    ['2017-05-01', 63],
    ['2017-06-01', 79],
    ['2017-07-01', 90],
    ['2017-08-01', 77],
    ['2017-09-01', 70],
    ['2017-10-01', 84],
    ['2017-11-01', 93],
    ['2017-12-01', 70],

    ['2018-01-01', 53],
    ['2018-02-01', 63],
    ['2018-03-01', 71],
    ['2018-04-01', 77],
    ['2018-05-01', 66],
    ['2018-06-01', 81],
    ['2018-07-01', 92],
    ['2018-08-01', 79],
    ['2018-09-01', 72],
    ['2018-10-01', 86],
    ['2018-11-01', 94],
    ['2018-12-01', 73],

    ['2019-01-01', 55],
    ['2019-02-01', 66],
    ['2019-03-01', 74],
    ['2019-04-01', 80],
    ['2019-05-01', 69],
    ['2019-06-01', 84],
    ['2019-07-01', 93],
    ['2019-08-01', 81],
    ['2019-09-01', 74],
    ['2019-10-01', 88],
    ['2019-11-01', 95],
    ['2019-12-01', 75],

    ['2020-01-01', 58],
    ['2020-02-01', 68],
    ['2020-03-01', 76],
    ['2020-04-01', 82],
    ['2020-05-01', 72],
    ['2020-06-01', 86],
    ['2020-07-01', 95],
    ['2020-08-01', 83],
    ['2020-09-01', 76],
    ['2020-10-01', 90],
    ['2020-11-01', 96],
    ['2020-12-01', 78],

    ['2021-01-01', 60],
    ['2021-02-01', 70],
    ['2021-03-01', 79],
    ['2021-04-01', 85],
    ['2021-05-01', 75],
    ['2021-06-01', 88],
    ['2021-07-01', 96],
    ['2021-08-01', 85],
    ['2021-09-01', 78],
    ['2021-10-01', 92],
    ['2021-11-01', 97],
    ['2021-12-01', 80],

    ['2022-01-01', 63],
    ['2022-02-01', 74],
    ['2022-03-01', 82],
    ['2022-04-01', 88],
    ['2022-05-01', 78],
    ['2022-06-01', 90],
    ['2022-07-01', 97],
    ['2022-08-01', 87],
    ['2022-09-01', 80],
    ['2022-10-01', 94],
    ['2022-11-01', 98],
    ['2022-12-01', 82],

    ['2023-01-01', 65],
    ['2023-02-01', 76],
    ['2023-03-01', 84],
    ['2023-04-01', 90],
    ['2023-05-01', 81],
    ['2023-06-01', 92],

    ['2024-01-01', 67],
    ['2024-02-01', 78],
    ['2024-03-01', 86],
    ['2024-04-01', 92],

    ['2025-01-01', 70],
    ['2025-02-01', 81],
    ['2025-03-01', 88],
    ['2025-04-01', 98]
  ]
};

export const watchlistReportChartData = {
  '1d': [
    ['9 AM', 250],
    ['9:30 AM', 372],
    ['10 AM', 360],
    ['10:30 AM', 106],
    ['11 AM', 354],
    ['11:30 AM', 170],
    ['12 PM', 104],
    ['12:30 PM', 333],
    ['1 PM', 225],
    ['1:30 PM', 160],
    ['2 PM', 152],
    ['2:30 PM', 353],
    ['3 PM', 112],
    ['3:30 PM', 238],
    ['4 PM', 109]
  ],
  '5d': [
    ['2025-03-05', 150],
    ['2025-03-06', 99],
    ['2024-03-07', 143],
    ['2025-03-08', 245],
    ['2025-03-09', 116]
  ],
  '1m': [
    ['2025-02-08', 175],
    ['2025-02-09', 17],
    ['2025-02-10', 263],
    ['2025-02-11', 184],
    ['2025-02-12', 271],
    ['2025-02-13', 209],
    ['2025-02-14', 77],
    ['2025-02-15', 98],
    ['2025-02-16', 223],
    ['2025-02-17', 354],
    ['2025-02-18', 139],
    ['2025-02-19', 226],
    ['2025-02-20', 237],
    ['2025-02-21', 31],
    ['2025-02-22', 218],
    ['2025-02-23', 389],
    ['2025-02-24', 72],
    ['2025-02-25', 77],
    ['2025-02-26', 23],
    ['2025-02-27', 39],
    ['2025-02-28', 328],
    ['2025-03-01', 269],
    ['2025-03-02', 333],
    ['2025-03-03', 135],
    ['2025-03-04', 386],
    ['2025-03-05', 226],
    ['2025-03-06', 356],
    ['2025-03-07', 222],
    ['2025-03-08', 67],
    ['2025-03-09', 23]
  ],
  '3m': [
    ['2024-12-02', 187],
    ['2024-12-07', 325],
    ['2024-12-12', 92],
    ['2024-12-17', 268],
    ['2024-12-22', 154],
    ['2024-12-27', 379],

    ['2025-01-03', 205],
    ['2025-01-08', 98],
    ['2025-01-13', 134],
    ['2025-01-18', 245],
    ['2025-01-23', 287],
    ['2025-01-28', 160],

    ['2025-02-04', 312],
    ['2025-02-09', 64],
    ['2025-02-14', 291],
    ['2025-02-22', 179],
    ['2025-03-03', 250],
    ['2025-03-10', 370]
  ],
  '6m': [
    ['2024-10-01', 125],
    ['2024-11-01', 298],
    ['2024-12-01', 212],
    ['2025-01-01', 173],
    ['2025-02-01', 356],
    ['2025-03-01', 290]
  ],
  '1y': [
    ['2024-03-01', 170],
    ['2024-04-30', 220],
    ['2024-05-05', 220],
    ['2024-06-29', 235],
    ['2024-07-04', 80],
    ['2024-08-28', 35],
    ['2024-09-02', 160],
    ['2024-10-27', 160],
    ['2024-11-01', 80],
    ['2024-12-31', 270],
    ['2025-01-05', 190],
    ['2025-02-28', 110]
  ],
  all: [
    ['2001-01-01', 40],
    ['2002-01-01', 110],
    ['2003-01-01', 190],
    ['2004-01-01', 70],
    ['2005-01-01', 220],
    ['2006-01-01', 220],
    ['2007-01-01', 304],
    ['2008-01-01', 235],
    ['2009-01-01', 80],
    ['2010-01-01', 35],
    ['2011-01-01', 160],
    ['2012-01-01', 80],
    ['2013-01-01', 160],
    ['2014-01-01', 270],
    ['2015-01-01', 158],
    ['2016-01-01', 282],
    ['2017-01-01', 304],
    ['2018-01-01', 387],
    ['2019-01-01', 94],
    ['2020-01-01', 34],
    ['2021-01-01', 301],
    ['2022-01-01', 324],
    ['2023-01-01', 321],
    ['2024-01-01', 179],
    ['2025-01-01', 55]
  ]
};
